import { Controller } from "@hotwired/stimulus"

// Collects browser fingerprint data and populates a hidden input field.
// Usage: <div data-controller="fingerprint">
//          <input type="hidden" data-fingerprint-target="field" name="client_metadata">
//        </div>
export default class extends Controller {
  static targets = ["field"]

  connect() {
    if (this.hasFieldTarget) {
      this.fieldTarget.value = JSON.stringify(this.collect())
    }
  }

  collect() {
    return {
      screen_resolution: `${screen.width}x${screen.height}`,
      viewport_size: `${window.innerWidth}x${window.innerHeight}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timezone_offset: new Date().getTimezoneOffset(),
      platform: navigator.platform,
      language: navigator.language,
      languages: Array.from(navigator.languages || []),
      color_depth: screen.colorDepth,
      device_memory: navigator.deviceMemory || null,
      hardware_concurrency: navigator.hardwareConcurrency || null,
      touch_support: navigator.maxTouchPoints > 0,
      cookie_enabled: navigator.cookieEnabled,
      do_not_track: navigator.doNotTrack
    }
  }
}
